/**
 * Rutas estáticas del módulo Simulacros (constructor + sesiones).
 */
const simulacrosRoutes = [
  {
    path: "/Sos/Emergencias/Simulacros/Constructor",
    name: "SimulacroConstructorIndex",
    component: () =>
      import("../views/sos/emergencias/simulacros/SimulacroConstructorIndex.vue"),
  },
  {
    path: "/Sos/Emergencias/Simulacros/Constructor/Nuevo",
    name: "SimulacroConstructorNuevo",
    component: () =>
      import("../views/sos/emergencias/simulacros/SimulacroConstructorEditor.vue"),
    props: { id: "Nuevo" },
  },
  {
    path: "/Sos/Emergencias/Simulacros/Constructor/:id",
    name: "SimulacroConstructorEditar",
    component: () =>
      import("../views/sos/emergencias/simulacros/SimulacroConstructorEditor.vue"),
    props: true,
  },
  {
    path: "/Sos/Emergencias/Simulacros/Sesion/:id/Briefing",
    name: "SimulacroSesionBriefing",
    component: () =>
      import("../views/sos/emergencias/simulacros/SimulacroSesionBriefing.vue"),
  },
  {
    path: "/Sos/Emergencias/Simulacros/Sesion/:id/Ejecucion",
    name: "SimulacroSesionEjecucion",
    component: () =>
      import("../views/sos/emergencias/simulacros/SimulacroSesionEjecucion.vue"),
  },
  {
    path: "/Sos/Emergencias/Simulacros/Sesion/:id/Mapa",
    name: "SimulacroSesionMapa",
    component: () =>
      import("../views/sos/emergencias/simulacros/SimulacroSesionMapa.vue"),
  },
  {
    path: "/Sos/Emergencias/Simulacros/Sesion/:id/Tour",
    name: "SimulacroSesionTour",
    component: () =>
      import("../views/sos/emergencias/simulacros/SimulacroSesionTour360.vue"),
  },
  {
    path: "/Sos/Emergencias/Simulacros/Sesion/:id/Evaluacion",
    name: "SimulacroSesionEvaluacion",
    component: () =>
      import("../views/sos/emergencias/simulacros/SimulacroSesionEvaluacion.vue"),
  },
  {
    path: "/Sos/Emergencias/Simulacros/Sesion/:id/Informe",
    name: "SimulacroSesionInforme",
    component: () =>
      import("../views/sos/emergencias/simulacros/SimulacroSesionInforme.vue"),
  },
];

export default simulacrosRoutes;
